/**
 * A aba está à vista? Muda quando a pessoa troca de aba ou minimiza a janela.
 *
 * Fora do render (num efeito, num callback), `abaVisivelAgora` lê o estado do
 * instante, sem esperar o próximo render.
 */

import { useSyncExternalStore } from 'react';

function inscreverVisibilidade(ouvinte: () => void): () => void {
  document.addEventListener('visibilitychange', ouvinte);
  return () => document.removeEventListener('visibilitychange', ouvinte);
}

export function abaVisivelAgora(): boolean {
  return document.visibilityState === 'visible';
}

export function useAbaVisivel(): boolean {
  return useSyncExternalStore(inscreverVisibilidade, abaVisivelAgora, () => true);
}
